// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2":"785eae68","25":"785eae68","256":"785eae68","442":"785eae68","544":"ea2280e2","591":"785eae68","615":"785eae68","737":"d0c084ce","976":"785eae68"}[chunkId] + ".chunk.css";
};